import React, { useEffect, useState, useRef } from "react";
import "./styles/horarios.css";
import { format, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";

export default function Horarios({ onLoaded }) {
  const [horarios, setHorarios] = useState({});
  const [loading, setLoading] = useState(true);
  const [diaSelecionado, setDiaSelecionado] = useState("");
  const tabsRef = useRef(null);

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      try {
        const res = await fetch(
          "https://arena-api-cyan.vercel.app/api/horarios"
        );

        if (!res.ok) {
          throw new Error(`Erro ${res.status}: ${res.statusText}`);
        }

        const data = await res.json();

        if (!isMounted || !data?.horarios) return;

        setHorarios(data.horarios);
      } catch (error) {
        console.error("Erro ao buscar horários:", error);
      } finally {
        if (isMounted) {
          setLoading(false);
          if (onLoaded) onLoaded();
        }
      }
    };

    fetchData();

    const interval = setInterval(fetchData, 20000); // atualiza a cada 20s

    return () => {
      isMounted = false;
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    if (!diaSelecionado && Object.keys(horarios).length > 0) {
      setDiaSelecionado(Object.keys(horarios)[0]);
    }
  }, [horarios]);

  const getDescricaoDia = (diaISO) => {
    const date = parseISO(diaISO);
    const diaSemana = format(date, "EEEE", { locale: ptBR });
    const dia = format(date, "dd/MM");
    return `${diaSemana.toLowerCase()} (${dia})`;
  };

  const formatarBotaoDia = (diaISO) => {
    const date = parseISO(diaISO);
    const dia = format(date, "dd/MM");
    const diaSemana = format(date, "EEEE", { locale: ptBR });
    return `${dia} (${capitalize(diaSemana)})`;
  };

  const capitalize = (str) =>
    str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

  const scrollLeft = () => {
    if (tabsRef.current) {
      tabsRef.current.scrollBy({ left: -150, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (tabsRef.current) {
      tabsRef.current.scrollBy({ left: 150, behavior: "smooth" });
    }
  };

  return (
    <div className="horarios-container">
      <h4>Selecione a data: </h4>

      <div className="tabs-wrapper">
        <button className="arrow left" onClick={scrollLeft}>
          ‹
        </button>
        <div className="tabs" ref={tabsRef}>
          {Object.keys(horarios).map((dia) => (
            <button
              key={dia}
              className={`tab ${dia === diaSelecionado ? "active" : ""}`}
              onClick={() => setDiaSelecionado(dia)}
            >
              {formatarBotaoDia(dia)}
            </button>
          ))}
        </div>
        <button className="arrow right" onClick={scrollRight}>
          ›
        </button>
      </div>

      <div className="grade-horarios">
        {loading ? (
          <p>Carregando horários...</p>
        ) : horarios[diaSelecionado]?.length === 0 ? (
          <p className="sem-horarios">
            Nenhum horário disponível para esta data.
          </p>
        ) : (
          horarios[diaSelecionado]?.map((hora, i) => {
            const diaDesc = getDescricaoDia(diaSelecionado);
            const horaInicio = hora.split(" - ")[0];
            const msg = `Olá, gostaria de reservar o horário ${horaInicio}, ${diaDesc}.`;

            const linkZap = `https://wa.me/5532999649956?text=${encodeURIComponent(
              msg
            )}`;

            return (
              <a
                key={i}
                className="horario-card"
                href={linkZap}
                target="_blank"
                rel="noopener noreferrer"
              >
                {hora}
              </a>
            );
          })
        )}
      </div>
    </div>
  );
}
